import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Что-то пошло не так',
  subTitle: {
    tryAgain: 'Попробуйте отправить форму позже',
    phone: 'Позвоните или <Link>напишите</Link> финансовому менеджеру <Phone>8 800 707-03-85</Phone>',
  },
  buttons: {
    close: 'Понятно',
  },
} as const satisfies TMessages
